// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"97":"Profile","143":"app","333":"CV","337":"Contact","894":"Story"}[chunkId] + "." + {"97":"e641a81a","143":"1c40d9e7","333":"5ad5be11","337":"23fda95f","894":"0a987ce9"}[chunkId] + ".css";
};